import { css, cx } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";
import { groupColors } from "@/modules/theme/utils/groupColors";

type LabelAdornmentProps = {
  text: string;
  className?: string;
  color?: string;
  isLarge?: boolean;
};

export const LabelAdornment = ({
  text,
  className,
  color = white,
  isLarge,
}: LabelAdornmentProps) => {
  const theme = useTheme();

  const bgColor = groupColors.find((current) => current.color === color)
    ?.backgroundColor;

  // if background color was found, use color & bg color
  // if not, fallback to white color and grey background
  const classes = createLabelAdornmentStyles(theme, {
    color: bgColor ? color : white,
    backgroundColor: bgColor ? bgColor : grey[900],
  });
  return (
    <div className={cx(className, classes.root, { [classes.large]: isLarge })}>
      {text}
    </div>
  );
};

export const createLabelAdornmentStyles = (
  { typography, spacing }: Theme,
  { color, backgroundColor }: { color: string; backgroundColor: string }
) => {
  return {
    root: css({
      display: "inline-block",
      borderRadius: 7,
      padding: spacing([0.5, 1]),
      fontSize: typography.pxToRem(11),
      lineHeight: typography.fontSize.default,
      fontWeight: typography.fontWeight.semiBold,
      color,
      backgroundColor,
    }),
    large: css({
      padding: spacing([1, 2]),
      fontSize: typography.pxToRem(12),
    }),
  };
};
